// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__z7FbT","approved":"Status_approved__1q3K7","rejected":"Status_rejected__IDNjK","expired":"Status_expired__1OpDS","label":"Status_label__Gp2M4"};